module.exports = __webpack_public_path__ + "img/orcid.959b1d06.png";